import * as canvasActions from './actions';
import * as constants from '../utils/constants';
import * as elementActions from '../elements/actions';
import * as elementLogics from '../elements/logics';
import * as textActions from '../text/actions';

import { NEW_RECENT_OFFSET, flipTypes, nextGenSidebarTabKeyEnum } from '../nextgen/constants';
import {
  adjustLogoOriginSizeByLimitation,
  getImageLayerIndex,
  getItemElementId,
  getRectPoints,
  initOriginalOptions,
  limitAndRepositionElement,
  limitAndRepositionTextElement,
  restoreOriginCropForUploadLogo,
  rotateText,
  switchToSharpened,
  switchToUnsharpened,
} from './logics';
import { saveImagePmsColors, setImageFlip } from '../nextgen/actions';

import { applyArt } from './actions';
import { checkAndSetLogoColorBeforeColorize } from '../uploadimage/logics';
import { checkShowImageColorized } from '../imprintarea/logics';
import { createReducer } from '@reduxjs/toolkit';
import { resetImageToOriginal } from '../nextgen/Upload/logics';
import { studioItemType as studioItemTypeEnum } from '../main/constants';
import { v4 as uuidv4 } from 'uuid';

export const canvasDict = createReducer({}, (builder) => {
  builder.addCase(canvasActions.initCanvas, (state, action) => {
    Object.assign(state, action.payload);
  });
});

export const imageDict = createReducer({}, (builder) => {
  builder
    .addCase(saveImagePmsColors, (state, action) => {
      if (!state[action.payload.canvasKey]) {
        state[action.payload.canvasKey] = [];
        return;
      }
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) image.ui.pmsColors = action.payload.pmsColors;
    })

    .addCase(canvasActions.setImageDict, (state, action) => {
      Object.assign(state, action.payload);
    })

    .addCase(canvasActions.initImageDict, (state, action) => {
      const { key, images } = action.payload;
      state[key] = images;
    })

    .addCase(canvasActions.selectImage, (state, action) => {
      if (!state[action.payload.canvasKey]) {
        state[action.payload.canvasKey] = [];
        return;
      }
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) image.ui.status = constants.elementStatus.SingleSelected;
    })

    .addCase(canvasActions.selectImageForNonDigital, (state, action) => {
      if (!state[action.payload.canvasKey]) {
        state[action.payload.canvasKey] = [];
        return;
      }
      let image = null;

      if (action.payload.guid) {
        image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.guid);
      } else if (
        action.payload.sidebarTabKey === constants.sidebarTabKeyEnum.Logo ||
        action.payload.sidebarTabKey === nextGenSidebarTabKeyEnum.Uploads
      )
        image = state[action.payload.canvasKey].find(
          (element) =>
            (typeof element.data.isOutside === 'undefined' || !element.data.isOutside) &&
            element.data.type !== constants.userImageType.Verse &&
            element.data.type !== constants.userImageType.Sentiment
        );
      else if (
        action.payload.sidebarTabKey === constants.sidebarTabKeyEnum.OutsideSlogan ||
        action.payload.sidebarTabKey === nextGenSidebarTabKeyEnum.Slogan
      )
        image = state[action.payload.canvasKey].find(
          (element) => typeof element.data.isOutside !== 'undefined' && element.data.isOutside
        );
      else if (
        action.payload.sidebarTabKey === constants.sidebarTabKeyEnum.Verse ||
        action.payload.sidebarTabKey === nextGenSidebarTabKeyEnum.Verse
      )
        image = state[action.payload.canvasKey].find((element) => element.data.type === constants.userImageType.Verse);
      else if (
        action.payload.sidebarTabKey === constants.sidebarTabKeyEnum.Sentiment ||
        action.payload.sidebarTabKey === nextGenSidebarTabKeyEnum.Sentiment
      )
        image = state[action.payload.canvasKey].find(
          (element) => element.data.type === constants.userImageType.Sentiment
        );

      if (image) image.ui.status = constants.elementStatus.SingleSelected;
    })

    .addCase(canvasActions.unSelectImage, (state, action) => {
      if (!state[action.payload.canvasKey]) {
        state[action.payload.canvasKey] = [];
        return;
      }
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) image.ui.status = constants.elementStatus.Unselected;
    })

    .addCase(canvasActions.batchSelectImage, (state, action) => {
      if (!state[action.payload.canvasKey]) {
        state[action.payload.canvasKey] = [];
        return;
      }
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) image.ui.status = constants.elementStatus.BatchSelected;
    })

    .addCase(canvasActions.unSelectAllImage, (state, action) => {
      const canvasKey = action.payload.canvasKey;
      if (state[canvasKey]) {
        // const studioItemType = action.payload.studioItemType;
        // if (
        //   typeof studioItemType !== 'undefined' &&
        //   studioItemType !== null &&
        //   studioItemType === studioItemTypeEnum.nonDigital
        // )
        //   return;
        state[canvasKey].forEach((image) => {
          image.ui.status = constants.elementStatus.Unselected;
        });
      }
    })
    .addCase(canvasActions.copyImageElement, (state, action) => {
      const element = action.payload.element;
      const canvasKey = action.payload.canvasKey;
      const draggingArea = action.payload.draggingArea;
      const canvasData = action.payload.canvasData;

      if (!state[canvasKey]) state[canvasKey] = [];
      const newElement = Object.assign({}, element);
      newElement.data = Object.assign({}, element.data);

      newElement.data.itemElementId = getItemElementId(canvasData);
      newElement.data.x += NEW_RECENT_OFFSET;
      newElement.data.y += NEW_RECENT_OFFSET;
      limitAndRepositionElement(newElement.data, draggingArea);

      newElement.data.zIndex = getImageLayerIndex(canvasData, true);

      newElement.ui = Object.assign({}, element.ui);
      newElement.ui.status = constants.elementStatus.SingleSelected;
      newElement.ui.guid = uuidv4();

      state[canvasKey] = [...state[canvasKey], newElement];
    })
    .addCase(canvasActions.addNewLogo, (state, action) => {
      const studioItemType = action.payload.studioItemType;
      const logoImageData = action.payload.logoImageData;
      const draggingArea = action.payload.draggingArea;
      const canvasKey = action.payload.canvasKey;
      const imprintColors = action.payload.imprintColors;
      const maxColorCount = action.payload.maxColorCount;
      const textColor = action.payload.textColor;
      const defaultImprintColor = action.payload.defaultImprintColor;
      const guid = action.payload.guid;
      const centerLogo = action.payload.centerLogo;

      if (!state[canvasKey]) state[canvasKey] = [];
      state[canvasKey].forEach((image) => {
        if (image.ui && image.ui.status === constants.elementStatus.SingleSelected)
          image.ui.status = constants.elementStatus.Unselected;
      });
      const newImage = {
        data: {},
        ui: {
          guid,
          status:
            studioItemType === studioItemTypeEnum.nonDigital ||
            studioItemType === studioItemTypeEnum.screenPrintedDigital
              ? constants.elementStatus.TempSelected
              : constants.elementStatus.SingleSelected,
          originalOptions: {
            autoCropRectOrigin: Object.assign({}, logoImageData.autoCropRect),
            cropRectOrigin: Object.assign({}, logoImageData.cropRect),
            finalCropRectOrigin: Object.assign({}, logoImageData.finalCropRect),
            logoResolutionX: logoImageData.logoResolutionX,
            logoResolutionY: logoImageData.logoResolutionY,
          },
        },
      };

      Object.assign(newImage.data, logoImageData);

      // init the AutoCropRect/CropRect to make sure they have correct values when calculating
      if (newImage.data.autoCropRect.width === 0 || newImage.data.autoCropRect.height === 0)
        newImage.data.autoCropRect = {
          x: 0,
          y: 0,
          width: newImage.data.originalWidth,
          height: newImage.data.originalHeight,
        };
      else newImage.data.isAutoCropped = true;

      if (newImage.data.cropRect.width === 0 || newImage.data.cropRect.height === 0)
        newImage.data.cropRect = {
          x: 0,
          y: 0,
          width: newImage.data.autoCropRect.width,
          height: newImage.data.autoCropRect.height,
        };
      else newImage.data.isCropped = true;

      newImage.data.zIndex = studioItemType === studioItemTypeEnum.nonDigital ? 0 : action.payload.layerIndex;
      newImage.data.itemElementId = action.payload.elementId;

      checkAndSetLogoColorBeforeColorize({
        currentLogo: newImage,
        studioItemType,
        maxColorCount,
        imprintColors,
        textColor,
        defaultImprintColor,
      });

      //check and adjust the image size and position
      limitAndRepositionElement(newImage.data, draggingArea);

      adjustLogoOriginSizeByLimitation(newImage.data, studioItemType, draggingArea);

      if (centerLogo) {
        newImage.data.x = Math.round((draggingArea.width - newImage.data.width) / 2 + draggingArea.x);
        newImage.data.y = Math.round((draggingArea.height - newImage.data.height) / 2 + draggingArea.y);
      }
      state[canvasKey] = [...state[canvasKey], newImage];
    })

    .addCase(canvasActions.updateCanvasImage, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) {
        Object.assign(image.data, action.payload.newImageData);

        if (action.payload.resetToOriginal) {
          resetImageToOriginal(image.data);
        }

        if (action.payload.draggingArea) {
          limitAndRepositionElement(image.data, action.payload.draggingArea);

          if (action.payload.newUploadedLogo) {
            adjustLogoOriginSizeByLimitation(image.data, action.payload.studioItemType, action.payload.draggingArea);
          }
        }
      }
    })

    .addCase(canvasActions.saveImageOriginColors, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) {
        if (image.data.colors) {
          image.ui.originColors = Object.assign([], image.data.colors);
        }
      }
    })

    .addCase(canvasActions.setColorizeFlag, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) {
        if (image.data.colors) {
          image.ui.isColorized = image.ui.isColorized || [];
          image.ui.isColorized[image.data.removeWhiteOption] = true;
        }
      }
    })

    .addCase(canvasActions.changeImageUiStatus, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.guid);
      if (image) {
        if (action.payload.unSharpenImageData !== undefined) {
          image.ui.unSharpenImageData = Object.assign({}, action.payload.unSharpenImageData);
          image.ui.unSharpenImageData.sharpenStatus = constants.imageSharpenStatus.Unsharpened;
        }
        if (action.payload.sharpenedImageData !== undefined) {
          image.ui.sharpenedImageData = Object.assign({}, action.payload.sharpenedImageData);
          image.ui.sharpenedImageData.sharpenStatus = constants.imageSharpenStatus.Sharpened;
        }
      }
    })

    .addCase(canvasActions.changeCropRect, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) {
        const oldResizeRatio = image.data.width / image.data.finalCropRect.width;

        //payload.autoCropRect/cropRect are based on direction angle=0, and canvasScale=1
        if (action.payload.autoCropRect.width !== 0 && action.payload.autoCropRect.height !== 0) {
          image.data.autoCropRect.x = Math.round(action.payload.autoCropRect.x);
          image.data.autoCropRect.y = Math.round(action.payload.autoCropRect.y);
          image.data.autoCropRect.width = Math.round(action.payload.autoCropRect.width);
          image.data.autoCropRect.height = Math.round(action.payload.autoCropRect.height);
        }
        if (action.payload.cropRect.width !== 0 && action.payload.cropRect.height !== 0) {
          image.data.cropRect.x = Math.round(action.payload.cropRect.x);
          image.data.cropRect.y = Math.round(action.payload.cropRect.y);
          image.data.cropRect.width = Math.round(action.payload.cropRect.width);
          image.data.cropRect.height = Math.round(action.payload.cropRect.height);

          // if not cropping, adjust the crop rect in order not to exceed the original width/height
          if (!action.payload.isCropping) {
            if (
              (image.data.autoCropRect.x || 0) + image.data.cropRect.x + image.data.cropRect.width >
              image.data.originalWidth
            )
              image.data.cropRect.width =
                image.data.originalWidth - (image.data.autoCropRect.x || 0) - image.data.cropRect.x;

            if (
              (image.data.autoCropRect.y || 0) + image.data.cropRect.y + image.data.cropRect.height >
              image.data.originalHeight
            )
              image.data.cropRect.height =
                image.data.originalHeight - (image.data.autoCropRect.y || 0) - image.data.cropRect.y;
          }
        }

        // get new finalCropRect
        image.data.finalCropRect.x = Math.round(image.data.autoCropRect.x + image.data.cropRect.x);
        image.data.finalCropRect.y = Math.round(image.data.autoCropRect.y + image.data.cropRect.y);
        image.data.finalCropRect.width = Math.round(
          image.data.cropRect.width || image.data.autoCropRect.width || image.data.originalWidth
        );
        image.data.finalCropRect.height = Math.round(
          image.data.cropRect.height || image.data.autoCropRect.height || image.data.originalHeight
        );

        image.data.width = Math.round(image.data.finalCropRect.width * oldResizeRatio);
        image.data.height = Math.round(image.data.finalCropRect.height * oldResizeRatio);
        image.data.isCropped = true;

        if (!action.payload.isCropping) {
          limitAndRepositionElement(image.data, action.payload.draggingArea);
        }
      }
    })

    .addCase(canvasActions.changeDirection, (state, action) => {
      if (state[action.payload.canvasKey]) {
        const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.guid);
        if (image) {
          image.data.direction = action.payload.direction;

          // adjust the iamge element position after rotation in ScreenPrintedDigial studio
          if (
            action.payload.studioItemType === studioItemTypeEnum.screenPrintedDigital ||
            action.payload.studioItemType === studioItemTypeEnum.digital
          ) {
            limitAndRepositionElement(image.data, action.payload.draggingArea);
          }
        }
      }
    })

    .addCase(canvasActions.changeLogoStatus, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) {
        image.ui.status = action.payload.status;
      }
    })

    .addCase(canvasActions.changeSloganYear, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) {
        image.data.sloganYear = action.payload.sloganYear;
        image.data.scene7FileName = `slogan_${image.data.sloganReference}_${action.payload.sloganYear}`;
      }
    })

    .addCase(canvasActions.changeImagePosition, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) {
        image.data.x = Math.round(action.payload.x);
        image.data.y = Math.round(action.payload.y);
      }
    })

    .addCase(canvasActions.changeImageSize, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (image) {
        image.data.width = Math.round(action.payload.width);
        image.data.height = Math.round(action.payload.height);
      }
    })

    .addCase(canvasActions.resizeElement, (state, action) => {
      let imageElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);

      if (imageElement) {
        //update store
        if (action.payload.x) {
          imageElement.data.x = Math.round(action.payload.x);
          imageElement.data.y = Math.round(action.payload.y);
        }

        imageElement.data.width = Math.round(action.payload.width);
        imageElement.data.height = Math.round(action.payload.height);
      }
    })

    .addCase(elementActions.rotateElement, (state, action) => {
      let imageElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      if (imageElement) {
        const direction = action.payload.direction;
        const pos = action.payload.position;
        imageElement.data.direction = direction;
        imageElement.data.x = pos.x;
        imageElement.data.y = pos.y;
      }
    })

    .addCase(canvasActions.updateElementDimension, (state, action) => {
      const { canvasKey, elementStatus, updateProps } = action.payload;
      if (!state[canvasKey]) state[canvasKey] = [];
      const foundArt = state[canvasKey].find((x) => x.ui.guid === updateProps.guid && x.ui.status === elementStatus);
      if (foundArt) {
        foundArt.data.width = Math.round(updateProps.width);
        foundArt.data.height = Math.round(updateProps.height);
        foundArt.data.originalWidth = Math.round(updateProps.originalWidth);
        foundArt.data.originalHeight = Math.round(updateProps.originalHeight);
        //foundArt.ui.url = updateProps.url;
      }
    })
    .addCase(canvasActions.addTemp, (state, action) => {
      const { canvasKey, newArt, studioItemType, draggingArea, centerArt } = action.payload;

      if (!state[canvasKey]) state[canvasKey] = [];

      // firstly, remove the temp art if exists
      const tempArt = state[canvasKey].find((element) => element.ui.status === constants.elementStatus.TempSelected);
      if (tempArt) {
        const index = state[canvasKey].indexOf(tempArt);
        state[canvasKey].splice(index, 1);
      }

      adjustLogoOriginSizeByLimitation(newArt.data, studioItemType, draggingArea);

      if (centerArt) {
        newArt.data.x = Math.round((draggingArea.width - newArt.data.width) / 2 + draggingArea.x);
        newArt.data.y = Math.round((draggingArea.height - newArt.data.height) / 2 + draggingArea.y);
      }
      state[canvasKey] = [...state[canvasKey], newArt];
    })
    .addCase(applyArt, (state, action) => {
      const { canvasKey, newArt, elementId, layerIndex } = action.payload;
      if (!state[canvasKey]) state[canvasKey] = [];
      newArt.data.customElement = true;
      newArt.data.itemElementId = elementId;
      newArt.data.zIndex = layerIndex;
      state[canvasKey] = [...state[canvasKey], newArt];
    })
    .addCase(canvasActions.addArt, (state, action) => {
      const { canvasKey, artData, newGuid, draggingArea, centerArt } = action.payload;
      const tempArt = state[canvasKey].find((x) => x.ui.status === constants.elementStatus.TempSelected);
      if (tempArt) {
        // not really a new art is added, but cancel new selection
        const isCancelSelection = tempArt.data.fileName !== artData.fileName;
        if (isCancelSelection) {
          const index = state[canvasKey].indexOf(tempArt);
          state[canvasKey].splice(index, 1);
        }

        state[canvasKey].forEach((image) => {
          image.ui.status = constants.elementStatus.Unselected;
        });

        if (isCancelSelection) {
          const newArt = {
            data: tempArt.data ? Object.assign(tempArt.data, artData) : artData,
            ui: tempArt.ui
              ? Object.assign(tempArt.ui, {
                  guid: newGuid,
                  status: constants.elementStatus.SingleSelected,
                })
              : {
                  guid: newGuid,
                  status: constants.elementStatus.SingleSelected,
                },
          };
          newArt.data.customElement = true;
          newArt.data.itemElementId = action.payload.elementId;
          newArt.data.zIndex = action.payload.layerIndex;

          if (newArt.data.type === constants.userImageType.UploadLogo) {
            restoreOriginCropForUploadLogo(newArt);
          }

          state[canvasKey].push(newArt);
        } else {
          tempArt.data.customElement = true;
          tempArt.data.itemElementId = action.payload.elementId;
          tempArt.ui.status = constants.elementStatus.SingleSelected;
          tempArt.ui.guid = newGuid; // create a new guid when adding the art to canvas

          if (centerArt) {
            tempArt.data.x = Math.round((draggingArea.width - tempArt.data.width) / 2 + draggingArea.x);
            tempArt.data.y = Math.round((draggingArea.height - tempArt.data.height) / 2 + draggingArea.y);
          }
        }
      }
    })

    .addCase(canvasActions.cancelSelectArt, (state, action) => {
      const tempArt = state[action.payload.canvasKey].find(
        (element) => element.ui.status === constants.elementStatus.TempSelected
      );
      if (tempArt) {
        const index = state[action.payload.canvasKey].indexOf(tempArt);
        state[action.payload.canvasKey].splice(index, 1);
      }
    })

    .addCase(canvasActions.changeStatusFromSelectedToTemp, (state, action) => {
      const singleSelectedArt = state[action.payload.canvasKey].find(
        (element) => element.ui.status === constants.elementStatus.SingleSelected
      );
      if (singleSelectedArt) singleSelectedArt.ui.status = constants.elementStatus.TempSelected;
    })

    .addCase(canvasActions.deleteImage, (state, action) => {
      const image = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.guid);
      if (image) {
        const index = state[action.payload.canvasKey].indexOf(image);
        state[action.payload.canvasKey].splice(index, 1);
      }
    })

    .addCase(canvasActions.deleteSavedArtImage, (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = state[key].filter((x) => x.data.type !== constants.userImageType.SavedArt);
      });
    })

    .addCase(canvasActions.layerUp, (state, action) => {
      const image = (state[action.payload.imprintAreaKey] || []).find(
        (element) => element.ui.guid === action.payload.guid
      );
      if (image) image.data.zIndex = action.payload.zIndexInfo.maxZIndex + 1;
    })

    .addCase(canvasActions.layerDown, (state, action) => {
      const image = (state[action.payload.imprintAreaKey] || []).find(
        (element) => element.ui.guid === action.payload.guid
      );
      if (image) image.data.zIndex = action.payload.zIndexInfo.minZIndex - 1;
    })

    .addCase(canvasActions.changeArtColor, (state, action) => {
      const { canvasKey, guid, colors, oldColor } = action.payload;
      const image = (state[canvasKey] || []).find((element) => element.ui.guid === guid);
      if (image) {
        if (oldColor) {
          // only change one color in the colors array
          const index = image.data.colors.findIndex((c) => c.colorId === oldColor.colorId);
          if (index !== -1) {
            image.data.colors[index] = colors[0];
          }
        } else {
          image.data.colors = colors || [];
        }
      }
    })

    .addCase(canvasActions.changeElementHorizonAlign, (state, action) => {
      let imageElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      if (imageElement) imageElement.data.x = action.payload.x;
    })

    .addCase(canvasActions.changeElementVerticalAlign, (state, action) => {
      let imageElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      if (imageElement) imageElement.data.y = action.payload.y;
    })

    .addCase(canvasActions.addInitImageElements, (state, action) => {
      const { studioType, imageDict, imprintAreaDict } = action.payload;
      if (imageDict) {
        Object.keys(imageDict).forEach((key) => {
          if (imageDict[key] && imageDict[key].length > 0) {
            const imageElementList = [];
            imageDict[key].forEach((image) => {
              const isColorized = checkShowImageColorized({
                studioType,
                userImage: image,
                imprintArea: imprintAreaDict[key],
              });
              const imageElement = { data: image };
              imageElement.ui = {
                guid: uuidv4(),
                status: constants.elementStatus.Unselected,
                rotateAngle: image.direction || 0,
                originColors: image.colors ? Object.assign([], image.colors) : [],
              };
              if (imageElement.data.type === constants.userImageType.UploadLogo) {
                // init the AutoCropRect/CropRect to make sure they have correct values when calculating
                if (imageElement.data.autoCropRect.width === 0 || imageElement.data.autoCropRect.height === 0)
                  imageElement.data.autoCropRect = {
                    x: 0,
                    y: 0,
                    width: imageElement.data.originalWidth,
                    height: imageElement.data.originalHeight,
                  };
                else imageElement.data.isAutoCropped = true;

                if (imageElement.data.cropRect.width === 0 || imageElement.data.cropRect.height === 0)
                  imageElement.data.cropRect = {
                    x: 0,
                    y: 0,
                    width: imageElement.data.autoCropRect.width,
                    height: imageElement.data.autoCropRect.height,
                  };
                else imageElement.data.isCropped = true;

                // set the static resolution property of the logo for edit back upload logo
                if (
                  studioType === studioItemTypeEnum.digital ||
                  studioType === studioItemTypeEnum.screenPrintedDigital
                ) {
                  imageElement.data.logoResolutionX = constants.MIN_CANVAS_DPI;
                  imageElement.data.logoResolutionY = constants.MIN_CANVAS_DPI;
                }

                //init original options data of upload logo in edit status
                initOriginalOptions(imageElement, image);
              } else {
                if (imageElement.ui.canEdit === undefined || imageElement.ui.canEdit === null) {
                  /**
                   * Process Colortype StockArt, SharedArt, SavedArt has multiple colors, can't be edited color
                   */
                  imageElement.ui.canEdit = !(image.colors && image.colors.length > 1) && isColorized;
                }

                if (imageElement.ui.topColorCount === undefined || imageElement.ui.topColorCount === null) {
                  if (image.colors) {
                    imageElement.ui.topColorCount = image.colors.length;
                  }
                }
              }

              imageElementList.push(imageElement);
            });
            state[key] = state[key] || [];
            Object.assign(state[key], imageElementList);
          }
        });
      }
    })

    .addCase(canvasActions.changeLogoColors, (state, action) => {
      const image = (state[action.payload.canvasKey] || []).find(
        (element) => element.ui.guid === action.payload.imageId
      );
      if (image && action.payload.colors) image.data.colors = action.payload.colors;
    })

    .addCase(canvasActions.setImageUI, (state, action) => {
      const { canvasKey, guid, ui, data } = action.payload;
      const image = (state[canvasKey] || []).find((element) => element.ui.guid === guid);
      if (image) {
        if (ui) {
          image.ui = image.ui || {};
          image.ui = Object.assign({}, image.ui, ui);
        }
        if (data) {
          image.data = image.data || {};
          image.data = Object.assign({}, image.data, data);
        }
      }
    })

    .addCase(canvasActions.updateElementByStatus, (state, action) => {
      const { canvasKey, status, data, ui } = action.payload;
      if (!state[canvasKey]) state[canvasKey] = [];
      const foundImages = state[canvasKey].filter((x) => x.ui.status === status);
      if (foundImages) {
        foundImages.forEach((image) => {
          if (ui) {
            image.ui = image.ui || {};
            image.ui = Object.assign({}, image.ui, ui);
          }
          if (data) {
            image.data = image.data || {};
            image.data = Object.assign({}, image.data, data);
          }
        });
      }
    })
    .addCase(canvasActions.resetUploadImageOptions, (state, action) => {
      const image = (state[action.payload.canvasKey] || []).find((element) => element.ui.guid === action.payload.guid);
      if (image) {
        const imageData = image.data;
        const imageDataOriginalOptions = image.data.originalOptions || {};
        const imageUiOriginalOptions = image.ui.originalOptions;
        imageData.direction = constants.rotateDirectionEnum.degrees0;
        imageData.colors = [];
        if (imageUiOriginalOptions) {
          imageData.autoCropRect = imageUiOriginalOptions.autoCropRectOrigin;
          imageData.cropRect = imageUiOriginalOptions.cropRectOrigin;
          imageData.finalCropRect = imageUiOriginalOptions.finalCropRectOrigin;
          imageData.width = imageUiOriginalOptions.finalCropRectOrigin.width;
          imageData.height = imageUiOriginalOptions.finalCropRectOrigin.height;
        } else {
          imageData.autoCropRect = imageDataOriginalOptions.autoCropRectOrigin;
          imageData.cropRect = imageDataOriginalOptions.cropRectOrigin;
          imageData.finalCropRect = imageDataOriginalOptions.finalCropRectOrigin;
          imageData.width = imageDataOriginalOptions.finalCropRectOrigin.width;
          imageData.height = imageDataOriginalOptions.finalCropRectOrigin.height;
        }
        limitAndRepositionElement(image.data, action.payload.draggingArea);
      }
    })

    .addCase(canvasActions.addArtForLite, (state, action) => {
      const { currentImprintAreaKey, artData } = action.payload;
      if (!state[currentImprintAreaKey]) state[currentImprintAreaKey] = [];

      if (state[currentImprintAreaKey].length > 0) {
        state[currentImprintAreaKey].splice(0, 1);
      }

      state[currentImprintAreaKey] = [...state[currentImprintAreaKey], artData];
    })

    .addCase(canvasActions.clearImageDict, (state, action) => {
      const { imprintAreaKey } = action.payload;
      state[imprintAreaKey] = [];
    })

    .addCase(canvasActions.changeToSharpened, (state, action) => {
      const image = (state[action.payload.canvasKey] || []).find(
        (element) => element.ui.guid === action.payload.imageId
      );
      if (image) {
        image.data.sharpenStatus = constants.imageSharpenStatus.Sharpened;
        switchToSharpened(image.data);
      }
    })

    .addCase(canvasActions.changeToUnsharpened, (state, action) => {
      const image = (state[action.payload.canvasKey] || []).find(
        (element) => element.ui.guid === action.payload.imageId
      );
      if (image) {
        image.data.sharpenStatus = constants.imageSharpenStatus.Unsharpened;
        switchToUnsharpened(image.data, action.payload.studioItemType);
      }
    })
    .addCase(canvasActions.changeSharpenMessageStatus, (state, action) => {
      const image = (state[action.payload.canvasKey] || []).find(
        (element) => element.ui.guid === action.payload.imageId
      );
      if (image) {
        if (action.payload.show !== undefined) {
          image.ui.sharpenMessageStatus = image.ui.sharpenMessageStatus || {};
          image.ui.sharpenMessageStatus.show = action.payload.show;
        }
      }
    })
    .addCase(canvasActions.setCanvasElementHighlight, (state, action) => {
      const image = state[action.payload.canvasKey]?.find((element) => element.ui.guid === action.payload.guid);
      if (image) image.ui.highlight = true;
    })
    .addCase(setImageFlip, (state, action) => {
      const image = state[action.payload.imprintAreaKey]?.find((element) => element.ui.guid === action.payload.guid);
      const flipType = action.payload.flipType;
      if (image) {
        switch (image.data.flipType) {
          case flipTypes.Horizontal:
            if (flipType === flipTypes.Horizontal) image.data.flipType = flipTypes.None;
            else image.data.flipType = flipTypes.HorizontalVertical;
            break;
          case flipTypes.Vertical:
            if (flipType === flipTypes.Horizontal) image.data.flipType = flipTypes.HorizontalVertical;
            else image.data.flipType = flipTypes.None;
            break;
          case flipTypes.HorizontalVertical:
            if (flipType === flipTypes.Horizontal) image.data.flipType = flipTypes.Vertical;
            else image.data.flipType = flipTypes.Horizontal;
            break;
          default:
            image.data.flipType = flipType;
        }
      }
    })
    .addCase(canvasActions.setRotateStart, (state, action) => {
      let { guid, imprintAreaKey, isRotateStart, startBySlider } = action.payload;

      let imageElement = elementLogics.getElement(state, imprintAreaKey, guid);
      if (imageElement) {
        imageElement.ui.isRotateStart = isRotateStart;
        imageElement.ui.startBySlider = startBySlider;
      }
    })
    .addCase(canvasActions.setRotateAngle, (state, action) => {
      let { guid, imprintAreaKey, currentAngle } = action.payload;

      let imageElement = elementLogics.getElement(state, imprintAreaKey, guid);
      if (imageElement) {
        imageElement.ui.rotateAngle = currentAngle;
      }
    })
    .addCase(canvasActions.setImageListByImprintAreaKeyAction, (state, action) => {
      const { imprintAreaKey, imageList } = action.payload;
      state[imprintAreaKey] = imageList;
    });
});

export const customBackgroundDict = createReducer({}, (builder) => {
  builder
    .addCase(canvasActions.initBackground, (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
        // set the static resolution property for edit back background
        state[key].logoResolutionX = constants.MIN_CANVAS_DPI;
        state[key].logoResolutionY = constants.MIN_CANVAS_DPI;
      });
    })

    .addCase(canvasActions.addBackgroundImage, (state, action) => {
      state[action.payload.canvasKey] = {};
      Object.assign(state[action.payload.canvasKey], action.payload.backgroundImageData);
    })

    .addCase(canvasActions.removeBackgroundImage, (state, action) => {
      delete state[action.payload];
    })
    .addCase(canvasActions.setCustomBackgroundDict, (state, action) => {
      Object.assign(state, action.payload);
    });
});

export const textDict = createReducer({}, (builder) => {
  builder
    .addCase(canvasActions.setTextDict, (state, action) => {
      Object.assign(state, action.payload);
    })

    .addCase(canvasActions.initText, (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = [];
        action.payload[key].forEach((element) => {
          state[key].push({
            data: element,
            ui: {
              guid: uuidv4(),
              status: constants.elementStatus.Unselected,
              visible: true,
            },
          });
        });
      });
    })
    .addCase(canvasActions.selectText, (state, action) => {
      const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (text) text.ui.status = constants.elementStatus.SingleSelected;
    })
    .addCase(canvasActions.returnSelectText, (state, action) => {
      const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (text) text.ui.status = constants.elementStatus.SingleSelected;
    })
    .addCase(canvasActions.unSelectText, (state, action) => {
      const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (text) text.ui.status = constants.elementStatus.Unselected;
    })
    .addCase(canvasActions.setCanvasElementHighlight, (state, action) => {
      const text = state[action.payload.canvasKey]?.find((element) => element.ui.guid === action.payload.guid);
      if (text) text.ui.highlight = true;
    })
    .addCase(canvasActions.batchSelectText, (state, action) => {
      const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (text) text.ui.status = constants.elementStatus.BatchSelected;
    })
    .addCase(canvasActions.returnBatchSelectText, (state, action) => {
      const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (text) text.ui.status = constants.elementStatus.BatchSelected;
    })
    .addCase(canvasActions.unSelectAllText, (state, action) => {
      const canvasKey = action.payload.canvasKey;
      let textElementList = elementLogics.getElementList(state, canvasKey);
      textElementList.forEach((text) => {
        text.ui.status = constants.elementStatus.Unselected;
        text.ui.highlight = false;
      });
    })
    .addCase(canvasActions.returnUnSelectAllText, (state, action) => {
      const canvasKey = action.payload.canvasKey;
      let textElementList = elementLogics.getElementList(state, canvasKey);
      textElementList.forEach((text) => {
        text.ui.status = constants.elementStatus.Unselected;
      });
    })
    .addCase(canvasActions.changeSelectedTextStatusToTemp, (state, action) => {
      const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.imageId);
      if (text) text.ui.status = constants.elementStatus.TempSelected;
    })
    .addCase(canvasActions.changeAllTextStatusToTemp, (state, action) => {
      const canvasKey = action.payload.canvasKey;
      let textElementList = elementLogics.getElementList(state, canvasKey);
      textElementList.forEach((text) => {
        text.ui.status = constants.elementStatus.TempSelected;
      });
    })
    .addCase(canvasActions.changeTextPosition, (state, action) => {
      const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.textId);
      if (text) {
        text.data.x = action.payload.x;
        text.data.y = action.payload.y;

        const degree = Math.max(text.data.direction, 0);
        let noRotateRect = { x: text.data.x, y: text.data.y, width: text.data.width, height: text.data.height };
        let textRotateResult = rotateText(getRectPoints(noRotateRect), degree);
        text.ui.outlineRect = textRotateResult.outlineRect;
      }
    })
    .addCase(canvasActions.deleteText, (state, action) => {
      const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.guid);
      if (text) {
        const index = state[action.payload.canvasKey].indexOf(text);
        state[action.payload.canvasKey].splice(index, 1);
      }
    })
    .addCase(canvasActions.layerUp, (state, action) => {
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      if (textElement) textElement.data.zIndex = action.payload.zIndexInfo.maxZIndex + 1;
    })
    .addCase(canvasActions.layerDown, (state, action) => {
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      if (textElement) textElement.data.zIndex = action.payload.zIndexInfo.minZIndex - 1;
    })
    .addCase(canvasActions.resizeElement, (state, action) => {
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);

      if (textElement) {
        //update store
        if (action.payload.fontSize) {
          textElement.data.fontSize = action.payload.fontSize;
        }
        textElement.data.x = Math.round(action.payload.x);
        textElement.data.y = Math.round(action.payload.y);
        textElement.data.width = Math.round(action.payload.width);
        textElement.data.height = Math.round(action.payload.height);
        textElement.ui.outlineRect = action.payload.outlineRect;
      }
    })
    .addCase(canvasActions.changeElementHorizonAlign, (state, action) => {
      // get textElement
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      if (textElement) {
        let diffX = action.payload.x - textElement.data.x;
        textElement.data.x = action.payload.x;
        textElement.ui.outlineRect.x += diffX;
      }
    })
    .addCase(canvasActions.changeElementVerticalAlign, (state, action) => {
      // get textElement
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      if (textElement) {
        let diffY = action.payload.y - textElement.data.y;
        textElement.data.y = action.payload.y;
        textElement.ui.outlineRect.y += diffY;
      }
    })
    .addCase(canvasActions.changeAllTextColorNonDigital, (state, action) => {
      let textElementList = elementLogics.getElementList(state, action.payload.imprintAreaKey);
      const newColor = action.payload.color;

      textElementList.forEach((textElement) => {
        textElement.data = textElement.data || {};
        textElement.data.color = textElement.data.color || {};

        textElement.data.color.cmyk = '';
        textElement.data.color.colorReference = newColor.colorReference;
        textElement.data.color.colorType = newColor.colorType;
        textElement.data.color.colorId = newColor.colorId;
        textElement.data.color.colorDescription = newColor.colorDescription;
      });
    })

    .addCase(elementActions.changeElement, (state, action) => {
      const imprintAreaKey = action.payload.imprintAreaKey;
      let changedElement = action.payload.element;
      // get textElement
      let textElement = elementLogics.getElement(state, imprintAreaKey, changedElement.ui.guid);
      // update store
      if (textElement) {
        const originalStatus = textElement.ui.status;
        Object.assign(textElement, changedElement);
        // keep original status
        textElement.ui.status = originalStatus;

        const degree = Math.max(textElement.data.direction, 0);
        let noRotateRect = {
          x: changedElement.data.x,
          y: changedElement.data.y,
          width: changedElement.data.width,
          height: changedElement.data.height,
        };
        let textRotateResult = rotateText(getRectPoints(noRotateRect), degree);
        textElement.ui.outlineRect = textRotateResult.outlineRect;
      }
    })

    .addCase(elementActions.dragElement, (state, action) => {
      // get textElement
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      textElement.data.x = action.payload.x;
      textElement.data.y = action.payload.y;

      const degree = Math.max(textElement.data.direction, 0);
      let noRotateRect = {
        x: textElement.data.x,
        y: textElement.data.y,
        width: textElement.data.width,
        height: textElement.data.height,
      };
      let textRotateResult = rotateText(getRectPoints(noRotateRect), degree);
      textElement.ui.outlineRect = textRotateResult.outlineRect;
    })

    .addCase(elementActions.selectSingleElement, (state, action) => {
      let textElementList = elementLogics.getElementList(state, action.payload.imprintAreaKey);
      textElementList.forEach((element) => {
        if (element.ui.guid === action.payload.guid) {
          element.ui.status = constants.elementStatus.SingleSelected;
        } else {
          element.ui.status = constants.elementStatus.Unselected;
        }
      });
    })

    .addCase(canvasActions.copyTextElement, (state, action) => {
      const element = action.payload.element;
      const canvasKey = action.payload.canvasKey;
      const batchMode = action.payload.batchMode;
      const draggingArea = action.payload.draggingArea;

      if (!state[canvasKey]) state[canvasKey] = [];
      const newElement = Object.assign({}, element);
      newElement.data = Object.assign({}, element.data);
      newElement.data.x += NEW_RECENT_OFFSET;
      newElement.data.y += NEW_RECENT_OFFSET;
      newElement.ui = Object.assign({}, element.ui);
      newElement.ui.status = batchMode ? constants.elementStatus.BatchSelected : constants.elementStatus.SingleSelected;
      newElement.ui.guid = uuidv4();

      const degree = Math.max(newElement.data.direction, 0);
      let noRotateRect = {
        x: newElement.data.x,
        y: newElement.data.y,
        width: newElement.data.width,
        height: newElement.data.height,
      };
      let textRotateResult = rotateText(getRectPoints(noRotateRect), degree);
      newElement.ui.outlineRect = textRotateResult.outlineRect;
      limitAndRepositionElement(newElement.data, draggingArea);

      state[canvasKey] = [...state[canvasKey], newElement];
    })

    .addCase(textActions.addTextElement, (state, action) => {
      // get textElementList
      let textElementList = elementLogics.getElementList(state, action.payload.imprintAreaKey);
      if (textElementList.length >= constants.CANVAS_MAX_TEXT) return;

      textElementList.forEach((item) => {
        item.ui.status = constants.elementStatus.Unselected;
        item.ui.isEditing = false;
        item.ui.inputState = {};
      });

      // add new text element to the store
      state[action.payload.imprintAreaKey].push(action.payload.textElement);
    })
    .addCase(textActions.changeFontSize, (state, action) => {
      // get textElement
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      // change fontsize
      textElement.data.fontSize = action.payload.fontSize;
      // change width/height
      textElement.data.width = Math.round(action.payload.width);
      textElement.data.height = Math.round(action.payload.height);

      // change position
      if (action.payload.positionModified) {
        textElement.data.x = action.payload.x;
        textElement.data.y = action.payload.y;
      }
    })
    .addCase(textActions.showAddText, (state, action) => {
      // get textElement
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      textElement.ui.status = constants.elementStatus.Unselected;
    })
    .addCase(textActions.initNonDigitalText, (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = [];
        action.payload[key].forEach((element) => {
          state[key].push({
            data: element,
            ui: {
              guid: uuidv4(),
              status: constants.elementStatus.Unselected,
            },
          });
        });
      });
    })
    .addCase(textActions.changeNonDigitalColor, (state, action) => {
      const guids = action.payload.guids;
      const selectedColor = action.payload.increment.data.color;
      let textElements = guids.map((guid) => elementLogics.getElement(state, action.payload.formatkey, guid));
      textElements.forEach((textElement) => {
        if (textElement.data.color === null) textElement.data.color = {};
        textElement.data.color.cmyk = '';
        textElement.data.color.colorReference = selectedColor.colorReference;
        textElement.data.color.colorType = selectedColor.colorType;
        textElement.data.color.colorId = selectedColor.colorId;
        textElement.data.color.colorDescription = selectedColor.colorDescription;
      });
    })
    .addCase(textActions.changeNonDigitalFontFace, (state, action) => {
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      textElement.data.fontFace = action.payload.fontFace;
      textElement.data.isBold = action.payload.isBold;
      textElement.data.isItalic = action.payload.isItalic;
    })
    .addCase(textActions.changeNonDigitalFontCode, (state, action) => {
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      textElement.data.fontCode = action.payload.selectedFontCode;
    })
    .addCase(textActions.changeNonDigitalTextStyle, (state, action) => {
      const isBold = action.payload.increment.data.isBold;
      const isItalic = action.payload.increment.data.isItalic;
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      textElement.data.isBold = isBold;
      textElement.data.isItalic = isItalic;
    })
    .addCase(textActions.changeNonDigitalFontSize, (state, action) => {
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      textElement.data.fontSizeText = action.payload.fontSizeText;
    })
    .addCase(textActions.changeFontSizesAndImprintFits, (state, action) => {
      const fontSizes = action.payload.fontSizes;
      const imprintFits = action.payload.imprintFits;
      let textElementList = elementLogics.getElementList(state, action.payload.imprintAreaKey);
      textElementList.forEach((text, index) => {
        if (fontSizes) {
          text.data.fontSize = fontSizes[index];
          text.data.imprintFits = imprintFits[index];
        }
      });
    })
    .addCase(textActions.changeNonDigitalText, (state, action) => {
      const imprintText = action.payload.imprintText;
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      textElement.data.imprintText = imprintText;
    })
    .addCase(textActions.changeStyleToAllNonDigitalText, (state, action) => {
      const guids = action.payload.guids;
      const fontFace = action.payload.increment.data.fontFace;
      const fontCode = action.payload.increment.data.fontCode;
      const fontSizeText = action.payload.increment.data.fontSizeText;
      const isBold = action.payload.increment.data.isBold;
      const isItalic = action.payload.increment.data.isItalic;
      let textElements = guids.map((guid) => elementLogics.getElement(state, action.payload.imprintAreaKey, guid));
      textElements.forEach((textElement) => {
        textElement.data.fontFace = fontFace;
        textElement.data.fontCode = fontCode;
        textElement.data.fontSizeText = fontSizeText;
        textElement.data.isBold = isBold;
        textElement.data.isItalic = isItalic;
      });
    })
    .addCase(textActions.changeTheSecondTabData, (state, action) => {
      const textTheSecondTab = state[action.payload.areaKey];
      const textTheFirstTab = action.payload.textList;
      if (textTheFirstTab.length > 0 && textTheSecondTab) {
        textTheSecondTab.forEach((text, index) => {
          text.data.imprintText = textTheFirstTab[index].data.imprintText;
          text.data.fontFace = textTheFirstTab[index].data.fontFace;
          text.data.fontCode = textTheFirstTab[index].data.fontCode;
          text.data.fontSizeText = textTheFirstTab[index].data.fontSizeText;
          text.data.isBold = textTheFirstTab[index].data.isBold;
          text.data.isItalic = textTheFirstTab[index].data.isItalic;
        });
      }
    })
    .addCase(textActions.clearText, (state, action) => {
      const imprintAreaKey = action.payload.imprintAreaKey;
      if (state[imprintAreaKey]) {
        state[imprintAreaKey] = [];
      }
    })
    .addCase(canvasActions.changeDirection, (state, action) => {
      if (state[action.payload.canvasKey]) {
        const text = state[action.payload.canvasKey].find((element) => element.ui.guid === action.payload.guid);
        if (text) {
          text.data.direction = action.payload.direction;
          let noRotateRect = { x: text.data.x, y: text.data.y, width: text.data.width, height: text.data.height };
          let rotateResultText = rotateText(getRectPoints(noRotateRect), action.payload.direction);
          let elementText = { ...text };
          elementText.ui.outlineRect = rotateResultText.outlineRect;
          let result = limitAndRepositionTextElement(elementText, action.payload.draggingArea);
          text.data.x = result.x;
          text.data.y = result.y;
          let noRotateRectText = { x: text.data.x, y: text.data.y, width: text.data.width, height: text.data.height };
          let rotateResult = rotateText(getRectPoints(noRotateRectText), action.payload.direction);
          text.ui.outlineRect = rotateResult.outlineRect;
        }
      }
    })
    .addCase(canvasActions.changeFontStyle, (state, action) => {
      let textElement = elementLogics.getElement(state, action.payload.imprintAreaKey, action.payload.guid);
      let increment = action.payload.increment;
      if (textElement) {
        textElement.data.isBold = increment.data.isBold;
        textElement.data.isItalic = increment.data.isItalic;
        textElement.data.isUnderline = increment.data.isUnderline;
        textElement.data.fontCode = increment.data.fontCode;
        textElement.ui.fontFileName = increment.ui.fontFileName;
      }
    })
    .addCase(canvasActions.setIsEditingText, (state, action) => {
      let { guid, imprintAreaKey, isEditing } = action.payload;
      let textElement = elementLogics.getElement(state, imprintAreaKey, guid);
      if (textElement) {
        if (isEditing) {
          textElement.ui.status = constants.elementStatus.SingleSelected;
        } else {
          textElement.ui.textWithSymbols = '';
          textElement.ui.inputState = null;
        }

        textElement.ui.isEditing = isEditing;
      }
    })
    .addCase(canvasActions.setEditingTextInputState, (state, action) => {
      let { guid, imprintAreaKey, inputState } = action.payload;
      let textElement = elementLogics.getElement(state, imprintAreaKey, guid);
      if (textElement) {
        textElement.ui.inputState = inputState;
      }
    })
    .addCase(canvasActions.setEditingTextSymbols, (state, action) => {
      let { guid, imprintAreaKey, textWithSymbols } = action.payload;
      let textElement = elementLogics.getElement(state, imprintAreaKey, guid);
      if (textElement) {
        textElement.ui.textWithSymbols = textWithSymbols;
      }
    })
    .addCase(canvasActions.setMaxAvailableFontSize, (state, action) => {
      let { guid, imprintAreaKey, maxAvailableFontSize } = action.payload;
      let textElement = elementLogics.getElement(state, imprintAreaKey, guid);
      if (textElement) {
        textElement.ui.maxAvailableFontSize = maxAvailableFontSize;
      }
    })
    .addCase(canvasActions.setRotateStart, (state, action) => {
      let { guid, imprintAreaKey, isRotateStart, startBySlider } = action.payload;

      let textElement = elementLogics.getElement(state, imprintAreaKey, guid);
      if (textElement) {
        textElement.ui.isRotateStart = isRotateStart;
        textElement.ui.startBySlider = startBySlider;
      }
    })
    .addCase(canvasActions.setRotateAngle, (state, action) => {
      let { guid, imprintAreaKey, currentAngle } = action.payload;

      let textElement = elementLogics.getElement(state, imprintAreaKey, guid);
      if (textElement) {
        textElement.ui.rotateAngle = currentAngle;
      }
    })
    .addCase(canvasActions.setTextListByImprintAreaKeyAction, (state, action) => {
      const { imprintAreaKey, textList } = action.payload;
      state[imprintAreaKey] = textList;
    });
});

export const textLineDict = createReducer({}, (builder) => {
  builder
    .addCase(textActions.initNonDigitalTextLine, (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = [];
        action.payload[key].forEach((element) => {
          state[key].push(element);
        });
      });
    })
    .addCase(textActions.changeNonDigitalTextLine, (state, action) => {
      const imprintAreaCode = action.payload.imprintAreaCode;
      if (state[imprintAreaCode]) {
        state[imprintAreaCode] = action.payload.nonDigitalTextDataList;
      }
    })
    .addCase(textActions.changeTextLineColor, (state, action) => {
      const imprintAreaCode = action.payload.imprintAreaCode;
      const selectedColor = action.payload.selectedColor;
      state[imprintAreaCode] &&
        state[imprintAreaCode].forEach((text) => {
          text.color = selectedColor;
        });
    });
});

export const superUserTextDict = createReducer({}, (builder) => {
  builder.addCase(textActions.changeSuperUserText, (state, action) => {
    state[action.payload.imprintAreaKey] = action.payload.superUserTextDict;
  });
});

export const undoRedoStack = createReducer({}, (builder) => {
  builder
    .addCase(canvasActions.pushToUndoStack, (state, action) => {
      state.undoList = state.undoList || [];
      state.undoList.push(action.payload);
      state.redoList = [];
    })

    .addCase(canvasActions.updatePrevTextDict, (state, action) => {
      state.undoList = state.undoList || [];
      if (state.undoList.length > 0) {
        var index = state.undoList.length - 1;
        state.undoList[index].textDict = action.payload;
      }
    })

    .addCase(canvasActions.updateFirstUndoText, (state, action) => {
      state.undoList = state.undoList || [];
      if (
        state.undoList.length > 0 &&
        state.undoList[0].textDict &&
        state.undoList[0].textDict[action.payload.canvasKey]
      ) {
        const textElement = state.undoList[0].textDict[action.payload.canvasKey].find(
          (text) => text.ui.guid === action.payload.text.ui.guid
        );
        if (textElement) {
          textElement.data = action.payload.text.data;
          textElement.ui = action.payload.text.ui;
        } else {
          // not found, add it
          state.undoList[0].textDict[action.payload.canvasKey].push(action.payload.text);
        }
      }
    })

    .addCase(canvasActions.updateLastUndoText, (state, action) => {
      state.undoList = state.undoList || [];
      if (state.undoList.length > 0) {
        var index = state.undoList.length - 1;
        if (state.undoList[index].textDict && state.undoList[index].textDict[action.payload.canvasKey]) {
          const textElement = state.undoList[index].textDict[action.payload.canvasKey].find(
            (text) => text.ui.guid === action.payload.text.ui.guid
          );
          if (textElement) {
            textElement.data = action.payload.text.data;
            textElement.ui = action.payload.text.ui;
          }
        }
      }
    })

    .addCase(canvasActions.changeUndoRedoList, (state, action) => {
      const isUndo = action.payload;
      if (isUndo) {
        if (state.undoList && state.undoList.length > 0) {
          const last = state.undoList.pop();
          state.redoList = state.redoList || [];
          state.redoList.unshift(last);
        }
      } else {
        if (state.redoList && state.redoList.length > 0) {
          const first = state.redoList.shift();
          state.undoList = state.undoList || [];
          state.undoList.push(first);
        }
      }
    })

    .addCase(canvasActions.clearUndoRedo, (state) => {
      state.undoList = [];
      state.redoList = [];
    });
});
